import React from "react";

import { icons } from "../../../constants";
import { onKeyDownHandler } from "../../../../../shared";

/**
 * Emoji grid overlay for the inbox message composer.
 */
const EmojiPickerPanel = ({ emojiPickerRef, onEmojiClick }) => {
  return (
    <div
      className="icon-container shadow-lg border border-2 bg-light rounded"
      ref={emojiPickerRef}
    >
      <div className="d-flex flex-wrap p-2">
        {icons.map((i) => (
          <div
            key={i.id}
            role="button"
            tabIndex={0}
            className="pointer p-1"
            data-testid="emoji-icon"
            onClick={() => onEmojiClick(i.icon)}
            onKeyDown={(e) => {
              onKeyDownHandler(e, () => {
                onEmojiClick(i.icon);
              });
            }}
          >
            {i.icon}
          </div>
        ))}
      </div>
    </div>
  );
};

export default EmojiPickerPanel;
